/**
 * @param {string | undefined} [className]
 * @returns {React.ReactElement}
 */
const CompanyLogoQuironPrevencion = ({ className }) => (
  <svg
    className={className}
    version="1.1"
    viewBox="712.07 294.5 2276.49 336"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
  >
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 769.5,294.5 C 779.713,297.106 789.046,301.606 797.5,308C 827.424,330.331 844.59,360.164 849,397.5C 849.5,453.166 849.667,508.832 849.5,564.5C 797.289,558.756 757.789,533.422 731,488.5C 711.323,451.244 706.99,412.244 718,371.5C 727.197,340.42 744.364,314.753 769.5,294.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#df3e51"
        d="M 912.5,335.5 C 913.873,335.343 915.207,335.51 916.5,336C 940.247,359.136 948.413,386.97 941,419.5C 932.393,448.44 913.56,466.94 884.5,475C 881.854,475.497 879.187,475.664 876.5,475.5C 876.333,447.498 876.5,419.498 877,391.5C 879.032,366.398 890.866,347.731 912.5,335.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 2653.5,372.5 C 2662.17,372.5 2670.83,372.5 2679.5,372.5C 2679.5,380.833 2679.5,389.167 2679.5,397.5C 2670.83,397.5 2662.17,397.5 2653.5,397.5C 2653.5,389.167 2653.5,380.833 2653.5,372.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#4a4f53"
        d="M 1266.5,381.5 C 1274.83,381.5 1283.17,381.5 1291.5,381.5C 1291.5,389.5 1291.5,397.5 1291.5,405.5C 1283.17,405.5 1274.83,405.5 1266.5,405.5C 1266.5,397.5 1266.5,389.5 1266.5,381.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#4a4f53"
        d="M 1472.5,404.5 C 1483.84,404.333 1495.17,404.5 1506.5,405C 1500.17,411.333 1493.83,417.667 1487.5,424C 1517.02,430.193 1533.19,448.359 1536,478.5C 1537.34,494.009 1536.34,509.342 1533,524.5C 1524.61,548.863 1507.45,562.03 1481.5,564C 1460.93,566.896 1441.93,562.896 1424.5,552C 1411.03,539.897 1403.87,524.73 1403,506.5C 1401.79,492.331 1402.79,478.331 1406,464.5C 1411.76,445.736 1423.93,433.236 1442.5,427C 1448.58,425.636 1454.58,424.136 1460.5,422.5C 1464.92,416.754 1468.92,410.754 1472.5,404.5 Z M 1461.5,444.5 C 1488.19,441.233 1504.35,452.566 1510,478.5C 1512.82,495.138 1510.82,511.138 1504,526.5C 1497.81,536.182 1488.98,541.682 1477.5,543C 1449.48,546.421 1433.31,534.254 1429,506.5C 1428.33,497.833 1428.33,489.167 1429,480.5C 1431.37,460.638 1442.2,448.638 1461.5,444.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 2778.5,404.5 C 2789.51,404.333 2800.51,404.5 2811.5,405C 2805.17,411.333 2798.83,417.667 2792.5,424C 2819.79,429.62 2835.95,446.12 2841,473.5C 2850.25,543.589 2820.08,573.089 2750.5,562C 2725.42,554.069 2711.59,536.903 2709,510.5C 2706.58,492.446 2708.25,474.779 2714,457.5C 2719.5,444 2729,434.5 2742.5,429C 2750.03,426.363 2757.69,424.363 2765.5,423C 2770.21,417.067 2774.55,410.9 2778.5,404.5 Z M 2767.5,444.5 C 2792.54,441.243 2808.37,451.577 2815,475.5C 2817.47,490.331 2816.81,504.998 2813,519.5C 2808.01,532.829 2798.51,540.663 2784.5,543C 2757.43,547.069 2740.93,535.903 2735,509.5C 2732.43,495.23 2733.43,481.23 2738,467.5C 2743.62,454.376 2753.45,446.709 2767.5,444.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#4a4f53"
        d="M 1009.5,423.5 C 1032.65,422.468 1055.48,424.468 1078,429.5C 1078.5,496.499 1078.67,563.499 1078.5,630.5C 1069.83,630.5 1061.17,630.5 1052.5,630.5C 1052.67,606.498 1052.5,582.498 1052,558.5C 1045.81,561.341 1039.31,563.174 1032.5,564C 976.469,569.304 949.636,543.804 952,487.5C 953.21,449.8 972.376,428.467 1009.5,423.5 Z M 1010.5,445.5 C 1020.17,445.334 1029.84,445.5 1039.5,446C 1043.8,446.374 1047.96,447.207 1052,448.5C 1052.83,477.506 1052.67,506.506 1051.5,535.5C 1037.08,542.125 1022.08,543.959 1006.5,541C 994.677,538.508 986.51,531.675 982,520.5C 976.421,503.605 976.088,486.605 981,469.5C 986.247,455.744 996.08,447.744 1010.5,445.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#4a4f53"
        d="M 1108.5,423.5 C 1116.83,423.5 1125.17,423.5 1133.5,423.5C 1133.33,454.502 1133.5,485.502 1134,516.5C 1136.12,534.449 1146.29,543.449 1164.5,543.5C 1179.74,541.963 1192.9,535.963 1204,525.5C 1204.5,491.502 1204.67,457.502 1204.5,423.5C 1212.83,423.5 1221.17,423.5 1229.5,423.5C 1229.5,470.5 1229.5,517.5 1229.5,564.5C 1223.5,564.5 1217.5,564.5 1211.5,564.5C 1210.77,558.586 1209.27,552.919 1207,547.5C 1183.99,564.584 1158.83,568.751 1131.5,560C 1117.89,552.63 1110.39,541.13 1109,525.5C 1108.5,491.502 1108.33,457.502 1108.5,423.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#4a4f53"
        d="M 1266.5,423.5 C 1274.83,423.5 1283.17,423.5 1291.5,423.5C 1291.5,470.5 1291.5,517.5 1291.5,564.5C 1283.17,564.5 1274.83,564.5 1266.5,564.5C 1266.5,517.5 1266.5,470.5 1266.5,423.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#4a4f53"
        d="M 1327.5,423.5 C 1333.51,423.334 1339.51,423.501 1345.5,424C 1347.23,429.406 1348.73,434.906 1350,440.5C 1362.47,428.853 1377.31,423.186 1394.5,423.5C 1394.83,430.532 1394.5,437.532 1393.5,444.5C 1377.76,444.956 1364.59,450.956 1354,462.5C 1353.5,496.498 1353.33,530.498 1353.5,564.5C 1344.83,564.5 1336.17,564.5 1327.5,564.5C 1327.5,517.5 1327.5,470.5 1327.5,423.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#4a4f53"
        d="M 1563.5,423.5 C 1569.54,423.171 1575.54,423.504 1581.5,424.5C 1583,429.828 1584.5,435.161 1586,440.5C 1608.15,423.072 1632.65,418.906 1659.5,428C 1675.06,435.584 1683.56,448.084 1685,465.5C 1685.5,498.498 1685.67,531.498 1685.5,564.5C 1676.83,564.5 1668.17,564.5 1659.5,564.5C 1659.97,530.451 1659.47,496.451 1658,462.5C 1652.58,449.943 1642.91,443.943 1629,444.5C 1613.72,445.698 1600.72,451.698 1590,462.5C 1589.5,496.498 1589.33,530.498 1589.5,564.5C 1580.83,564.5 1572.17,564.5 1563.5,564.5C 1563.5,517.5 1563.5,470.5 1563.5,423.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 1757.5,423.5 C 1824.35,417.864 1852.52,448.197 1842,514.5C 1836.33,544.169 1818.5,560.669 1788.5,564C 1773.32,565.926 1758.65,564.093 1744.5,558.5C 1743.5,582.491 1743.17,606.491 1743.5,630.5C 1735.17,630.5 1726.83,630.5 1718.5,630.5C 1718.5,563.167 1718.5,495.833 1718.5,428.5C 1731.61,426.601 1744.61,424.935 1757.5,423.5 Z M 1757.5,445.5 C 1767.51,445.334 1777.51,445.5 1787.5,446C 1805.66,449.828 1815.83,460.994 1818,479.5C 1820.86,498.015 1817.2,515.015 1807,530.5C 1798.19,538.718 1787.69,542.718 1775.5,542.5C 1764.69,542.215 1754.36,539.881 1744.5,535.5C 1743.33,506.506 1743.17,477.506 1744,448.5C 1748.56,447.294 1753.06,446.294 1757.5,445.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 1869.5,423.5 C 1875.5,423.5 1881.5,423.5 1887.5,423.5C 1888.53,429.289 1890.03,434.955 1892,440.5C 1904.1,428.854 1918.6,423.187 1935.5,423.5C 1935.5,430.833 1935.5,438.167 1935.5,445.5C 1919.94,445.071 1906.78,450.404 1896,461.5C 1895.5,495.832 1895.33,530.165 1895.5,564.5C 1886.83,564.5 1878.17,564.5 1869.5,564.5C 1869.5,517.5 1869.5,470.5 1869.5,423.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 1999.5,423.5 C 2016.69,421.74 2033.02,424.573 2048.5,432C 2059.14,439.079 2065.97,448.912 2069,461.5C 2071.66,474.752 2072.16,488.086 2070.5,501.5C 2037.5,501.5 2004.5,501.5 1971.5,501.5C 1972.6,526.432 1985.6,540.265 2010.5,543C 2028.75,544.324 2046.75,542.824 2064.5,538.5C 2064.5,545.5 2064.5,552.5 2064.5,559.5C 2039.59,565.393 2014.59,565.893 1989.5,561C 1963.86,552.936 1949.69,535.436 1947,508.5C 1946.33,497.833 1946.33,487.167 1947,476.5C 1950.72,444.949 1968.22,427.282 1999.5,423.5 Z M 2001.5,444.5 C 2029.51,440.633 2044.51,452.633 2046.5,480.5C 2021.49,480.833 1996.49,480.5 1971.5,479.5C 1973,460.349 1983,448.683 2001.5,444.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 2076.5,423.5 C 2085.86,423.168 2095.19,423.502 2104.5,424.5C 2117.57,460.205 2130.73,495.872 2144,531.5C 2157,495.833 2170,460.167 2183,424.5C 2192.08,423.515 2201.25,423.182 2210.5,423.5C 2192.41,470.36 2173.74,517.027 2154.5,563.5C 2146.19,564.498 2137.86,564.831 2129.5,564.5C 2112.03,517.434 2094.37,470.434 2076.5,423.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 2269.5,423.5 C 2325.13,420.141 2348.8,446.141 2340.5,501.5C 2307.83,501.5 2275.17,501.5 2242.5,501.5C 2242.75,526.585 2255.41,540.419 2280.5,543C 2298.75,544.324 2316.75,542.824 2334.5,538.5C 2334.83,545.532 2334.5,552.532 2333.5,559.5C 2312.07,564.597 2290.4,565.764 2268.5,563C 2236.9,556.394 2219.74,536.894 2217,504.5C 2214.18,483.044 2218.18,463.044 2229,444.5C 2239.9,432.303 2253.4,425.303 2269.5,423.5 Z M 2271.5,444.5 C 2284.19,442.604 2295.85,445.104 2306.5,452C 2313.73,460.07 2317.06,469.57 2316.5,480.5C 2291.83,480.5 2267.17,480.5 2242.5,480.5C 2243.19,461.049 2252.86,449.049 2271.5,444.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 2367.5,423.5 C 2373.18,423.334 2378.84,423.501 2384.5,424C 2386.23,429.406 2387.73,434.906 2389,440.5C 2414.42,421.203 2441.58,418.369 2470.5,432C 2480.85,439.865 2486.69,450.365 2488,463.5C 2488.5,497.165 2488.67,530.832 2488.5,564.5C 2480.17,564.5 2471.83,564.5 2463.5,564.5C 2463.95,531.468 2463.45,498.468 2462,465.5C 2457.56,451.416 2447.9,444.749 2433,445.5C 2417.43,445.951 2404.1,451.617 2393,462.5C 2392.5,496.498 2392.33,530.498 2392.5,564.5C 2384.17,564.5 2375.83,564.5 2367.5,564.5C 2367.5,517.5 2367.5,470.5 2367.5,423.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 2575.5,423.5 C 2592.31,422.821 2608.97,423.987 2625.5,427C 2627.44,433.885 2628.11,441.052 2627.5,448.5C 2611.34,445.084 2595,443.917 2578.5,445C 2552.04,449.032 2539.04,464.532 2539.5,491.5C 2539.41,505.397 2543.24,518.063 2551,529.5C 2558.62,537.058 2567.78,541.558 2578.5,543C 2595.02,544.186 2611.35,543.02 2627.5,539.5C 2628.11,546.948 2627.44,554.115 2625.5,561C 2602.07,565.996 2578.74,565.663 2555.5,560C 2533.04,551.937 2519.88,536.103 2516,512.5C 2513,494.143 2514.33,476.143 2520,458.5C 2527.71,441.79 2540.55,431.29 2558.5,427C 2564.3,425.816 2569.97,424.649 2575.5,423.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 2653.5,423.5 C 2662.17,423.5 2670.83,423.5 2679.5,423.5C 2679.5,470.5 2679.5,517.5 2679.5,564.5C 2670.83,564.5 2662.17,564.5 2653.5,564.5C 2653.5,517.5 2653.5,470.5 2653.5,423.5 Z"
      />
    </g>
    <g>
      <path
        style={{ opacity: 1 }}
        fill="#00b2a8"
        d="M 2867.5,423.5 C 2873.5,423.5 2879.5,423.5 2885.5,423.5C 2886.23,429.414 2887.73,435.081 2890,440.5C 2912.88,422.439 2938.04,418.605 2965.5,429C 2978.83,436.127 2986.33,447.293 2988,462.5C 2988.5,496.498 2988.67,530.498 2988.5,564.5C 2980.17,564.5 2971.83,564.5 2963.5,564.5C 2963.96,531.131 2963.46,497.798 2962,464.5C 2957.35,450.668 2947.69,444.335 2933,445.5C 2917.43,445.951 2904.1,451.617 2893,462.5C 2892.5,496.498 2892.33,530.498 2892.5,564.5C 2884.17,564.5 2875.83,564.5 2867.5,564.5C 2867.5,517.5 2867.5,470.5 2867.5,423.5 Z"
      />
    </g>
  </svg>
);

export default CompanyLogoQuironPrevencion;
